import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'frequencyType'
})
export class FrequencyTypePipe implements PipeTransform {

  transform(numberChannels: unknown, ...args: unknown[]): unknown {
    if (numberChannels < 129) {
      return 'continuum';
    } else {
      return 'line';
    }
  }

}
